import styled from "@emotion/styled";
import { colors } from "../../styles/colors";

export const ItemPage = styled.div`
  padding: 3px 7px;
  border-radius: 25px;
  cursor: pointer;
  color: inherit;
  display: flex;
  align-items: center;
  line-height: 1;
  &:hover,
  &.active {
    color: ${colors.WHITE};
    background-color: ${colors.RED};
    .icon {
      stroke: ${colors.WHITE};
    }
  }
`;

export const ItemDots = styled.div`
  adding: 3px 7px;
  color: inherit;
  display: flex;
  align-items: center;
  line-height: 1;
`;

export const Item = styled.li`
  margin: 5px 0;
  ${(props) =>
    props.disabled
      ? ` 
    color: ${colors.GREY};
    pointer-events: none;
    .icon{
      stroke: ${colors.GREY};
    }
    `
      : ` color: ${colors.GREY_DARK}; `}
  @media (min-width: 769px) {
    margin: 5px 8px;
  }
`;
export const ItemPrev = styled(Item)`
  .icon {
    margin-right: 3px;
  }
  @media (min-width: 769px) {
    .icon {
      margin-right: 11px;
    }
  }
`;

export const ItemNext = styled(Item)`
  .icon {
    margin-left: 3px;
  }
  @media (min-width: 769px) {
    .icon {
      margin-left: 11px;
    }
  }
`;

export const PaginationWrap = styled.ul`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  font-size: 18px;
  list-style: none;
  padding: 0;
  margin: 0;
`;
